import { to, ColorSpace, contrastAPCA, get, HSL, parse, sRGB, deltaE, set, serialize } from 'colorjs.io/fn'


// const getBrightness = (rgb) => {
//     //http://www.w3.org/TR/AERT#color-contrast
//     var rgb = this.toRgb();
//     return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
// }


const getContrast = (bg, fg) => {
    return Math.abs(contrastAPCA(bg, fg))
}

const isDarkColor = (c) => {
    const colorWhite = { space: 'srgb', coords: [1, 1, 1] }
    const colorDark = { space: 'srgb', coords: [0, 0, 0] }
    
    const dl = deltaE(c, colorWhite, 'ITP')
    const dd = deltaE(c, colorDark, 'ITP')

    return dl > dd
} 


const getContrastBgColor = (bg, fg, defBg, ratio = 75) => {
    ColorSpace.register(sRGB)
    ColorSpace.register(HSL)

    const cFg = parse(fg)
    const cBg = parse(bg)
    const bgHSL = to(cBg, 'HSL')

    if(getContrast(cBg, cFg) >= ratio) {
        return bg
    } else {
        const i = isDarkColor(cFg) ? 1 : -1
        const l = get(bgHSL, 'l')

        for(let nl = l; (nl > -1 && nl < 101); nl = nl + i) {
            const nbgHSL = set(bgHSL, 'l', nl)

            if(getContrast(nbgHSL, cFg) >= ratio) {
                return serialize(to(nbgHSL, 'sRGB'), { format: 'hex' })
            }
        }
    }

    return defBg
}

export default getContrastBgColor